import search from "../../assets/icons/search.svg";
import { useState } from "react";
import styles from "./SearchBar.module.scss";
import { useNavigate } from "react-router-dom";

export default function SearchBar({}) {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const HandleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchData();
    }
  };
  const searchData = async () => {
    searchValue !== "" && navigate(`/search/${searchValue}`);
  };
  return (
    <>
      <div className={styles.searchWrapper}>
        <input
          // onKeyDown={HandleKeyDown}
          type="search"
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          placeholder="Szukaj"
        />
        <img src={search} onClick={searchData} />
      </div>
    </>
  );
}
